import { Box, Tooltip } from '@chakra-ui/react';
import { NotAllowedIcon } from '@chakra-ui/icons';

export const ConnectionLost = () => {
    return (
        <Box pb="3px" pr={2}>
            <Tooltip label="Connection lost" openDelay={1000}>
                <NotAllowedIcon color="gray" boxSize="14px" title="Connection lost" />
            </Tooltip>
        </Box>
    );
};
